import { Building2 } from 'lucide-react';

import type { NavItem } from '@/components/layout/nav';

/**
 * Sidebar entry for the organizations feature (design §6: P1 ships exactly two
 * nav items — Home, contributed by the auth feature, and this one).
 * `components/layout/nav.ts` collects it by glob, so the shell never learns
 * about features.
 */
export const nav: NavItem[] = [
  { to: '/organizations', label: 'Organizations', icon: Building2, match: 'prefix' },
];
